import React from 'react'
import { combineStyles } from '../../misc/theming'
import classNames from 'classnames/bind'

function Themed(props) {
  const styles = combineStyles(props.styles, props.theme)
  const cx = classNames.bind(styles)

  return props.children(cx, styles)
}

export default Themed
